import { baseUrl } from './baseUrl'

export async function fetchJSON<T>(url: string): Promise<T> {
  return (await fetch(baseUrl(url), { cache: 'no-cache' })).json()
}
